module.exports = __webpack_public_path__ + "static/media/03操控.a50e79e1.jpg";